import React, { FC } from 'react';

export const SvgSuccessIcon: FC = ({ ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
        <path
            fill="#26CD58"
            fillRule="evenodd"
            d="M1.686 1.686C.373 2.999.276 4.306.081 6.923.031 7.6 0 8.3 0 9s.03 1.399.081 2.077c.195 2.616.292 3.924 1.605 5.237 1.313 1.313 2.62 1.41 5.237 1.605C7.6 17.969 8.3 18 9 18s1.399-.03 2.077-.081c2.616-.195 3.924-.292 5.237-1.605 1.313-1.313 1.41-2.62 1.605-5.237C17.969 10.4 18 9.7 18 9s-.03-1.399-.081-2.077c-.195-2.616-.292-3.924-1.605-5.237C15.001.373 13.694.276 11.077.081A28.107 28.107 0 0 0 9 0c-.7 0-1.399.03-2.077.081-2.616.195-3.924.292-5.237 1.605Zm11.521 5.521a1 1 0 0 0-1.414-1.414L8 9.586 6.707 8.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z"
            clipRule="evenodd"
        />
    </svg>
);
